import React from 'react';
import Header from "../../Header";

import './birthday.css'

import { birthdayImages } from './birthday.image'


const Birthday = ({ openBurger, isOpen }) => {
    return (
        <div className="birthday">
            <Header openBurger={openBurger} isOpen={isOpen} title="Gâteau d'anniversaire" />
            <h2 className="main-title">Gallerie</h2>
            <div className="birthday__container">

                {
                    birthdayImages.map((image, index) => (
                        <div key={index} className="birthday__contain">
                            <img src={image} alt="birthday" className="birthday__contain__image" />
                        </div>
                    ))
                }
            </div>
        </div>

    );
};

export default Birthday;